<div class="mb-5" *ngFor="let accordionData of accordionWithImage; let i = index">
  <div class="accordion-apiDoc">
    <div class="card-header">
      <h4 (click)="toggleCollapsed(i)" class="flex-text">
        <div [ngClass]="getArrowIcons(i)" class="arrow-icon">
          {{ accordionData.title }}
        </div>
      </h4>
    </div>
    <div [ngClass]="getAccordionStyle(i)" class="mt-3">
      <div class="collapsible card-body" [innerHTML]="accordionData.body || '' | mdToHtml"></div>
    </div>
  </div>
</div>
